import { useTranslation } from "react-i18next";

/* Monogrammes neutres pour les emplacements réservés — remplacés par les vrais logos */
const Mark = ({ i }) => {
  const k = i % 4;
  const cls = "h-5 w-5";
  if (k === 0)
    return (
      <svg viewBox="0 0 24 24" fill="none" className={`${cls} text-ostelo-blue`} aria-hidden="true">
        <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2.5" />
      </svg>
    );
  if (k === 1)
    return (
      <svg viewBox="0 0 24 24" fill="none" className={`${cls} text-ostelo-deep`} aria-hidden="true">
        <rect x="5" y="5" width="14" height="14" rx="4" stroke="currentColor" strokeWidth="2.5" />
      </svg>
    );
  if (k === 2)
    return (
      <svg viewBox="0 0 24 24" fill="none" className={`${cls} text-ostelo-green`} aria-hidden="true">
        <path d="M4 20v-8a8 8 0 0 1 16 0v8" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    );
  return (
    <svg viewBox="0 0 24 24" fill="none" className={`${cls} text-ostelo-orange`} aria-hidden="true">
      <path d="M12 3v18M3 12h18M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export const LogoMarquee = () => {
  const { t } = useTranslation();
  const items = t("home.marquee_logos", { returnObjects: true });
  const row = [...items, ...items, ...items];

  return (
    <div className="border-b border-ostelo-deep/5 bg-white py-8 max-md:hidden" data-testid="logo-marquee">
      <p className="px-6 text-center text-[10px] font-bold uppercase tracking-[0.25em] text-ostelo-ink/30">
        {t("home.marquee_caption")}
      </p>
      <div className="mt-6 overflow-hidden" aria-hidden="true">
        <div className="flex w-max animate-marquee items-center">
          {[0, 1].map((half) => (
            <div key={half} className="flex items-center">
              {row.map((label, i) => (
                <div
                  key={`${half}-${i}`}
                  className="mx-10 flex items-center gap-2.5 opacity-35 transition-opacity duration-300 hover:opacity-90"
                >
                  <Mark i={i} />
                  <span className="whitespace-nowrap font-display text-lg font-semibold text-ostelo-deep">{label}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
